import { Injectable } from '@angular/core';
import { FirestoreProvider } from './firestore.provider';
import { AuthProvider } from '../auth/auth.provider';

@Injectable()
export class UsersFirestoreProvider extends FirestoreProvider {

  constructor(private authProvider: AuthProvider) {
    super();
  }

  public getCurrentUserData():any {
     if (this.authProvider.isAuthenticated()) return this.getDocument(`users/${this.authProvider.getUserId()}`);
     else return null;
  }

  public updateCurrentUser(update: object):any {
    return this.updateDocument(`users/${this.authProvider.getUserId()}`, update);
  }

}
